export const menuLists = [
    {
        name: '首页',
        path: '/',
        activeRouteName: 'Home'
    }, {
        name: '简介',
        path: '/introduction',
        activeRouteName: 'Introduction'
    }, {
        name: '展览',
        path: '/exhibition',
        activeRouteName: 'Exhibition'
    }, {
        name: '文物',
        path: '/cultural-relics',
        activeRouteName: 'CulturalRelics'
    }, {
        name: '资讯',
        path: '/information',
        activeRouteName: 'Information'
    }, {
        name: '宣教',
        path: '/information?id=16',
        activeRouteName: 'PublicEducation',
        children: [
            {
                name: '网络课堂',
                path: '/information?id=16'
            },
            {
                name: '藏品知识',
                path: '/information?id=17'
            },
            {
                name: '社会教育',
                path: '/information?id=18'
            },
            {
                name: '科研成果',
                path: '/information?id=19'
            },
            {
                name: '博物馆活动',
                path: '/information?id=20'
            },
            {
                name: '历史传承',
                path: '/information?id=22'
            }
        ]
    }, {
        name: '学术',
        path: '/academic',
        activeRouteName: 'Academic'
    }, {
        name: '文创',
        path: '/cultural-creative',
        activeRouteName: 'CulturalCreative'
    }, {
        name: '论坛',
        path: '/questionnaire',
        activeRouteName: 'Forum',
        children: [
            {
                name: '问卷调查',
                path: '/questionnaire'
            },
            {
                name: '互动留言',
                path: '/luiyan'
            },
            {
                name: '常见问题',
                path: '/information?id=21'
            }
        ]
    }
];
